import { validationMessage } from "../consts/ValidationMessage";
import {
  isAlphaSpecialChar,
  isAlphaUnderscoreHyphen,
  isMaxLength,
  isValidPostalCodeWithHyphen,
  isWithinRange,
  validateRequiredFields,
  ValidationErrors,
} from "./validationUtils";

export const validate = (
  form: Record<string, string>,
  setErrors: (errors: ValidationErrors) => void,
): boolean => {
  const requiredFields: string[] = [
    "corporateName",
    "postalCode",
    "city",
    "streetAddress",
    "chargeLastName",
    "chargeFirstName",
    "cybozuDomain",
  ];
  const errorMessages = {
    corporateName: `会社名・団体名・屋号${validationMessage.REQUIRED}`,
    postalCode: `郵便番号${validationMessage.REQUIRED}`,
    city: `市区町村${validationMessage.REQUIRED}`,
    streetAddress: `町名番地・建物名${validationMessage.REQUIRED}`,
    corporatePhoneNumber: `代表電話番号${validationMessage.REQUIRED}`,
    department: `部署名${validationMessage.REQUIRED}`,
    chargeLastName: `契約担当者（姓）${validationMessage.REQUIRED}`,
    chargeFirstName: `契約担当者（名）${validationMessage.REQUIRED}`,
    chargeLastNameKana: `契約担当者（姓 かな）${validationMessage.REQUIRED}`,
    chargeFirstNameKana: `契約担当者（名 かな）${validationMessage.REQUIRED}`,
    cybozuDomain: `Cybozuドメイン${validationMessage.REQUIRED}`,
  };

  const validationErrors = validateRequiredFields(
    form,
    requiredFields,
    errorMessages
  );

  // 郵便番号のバリデーション（トライアル/本契約共通）
  if (
    !validationErrors.postalCode &&
    !isValidPostalCodeWithHyphen(form.postalCode)
  ) {
    validationErrors.postalCode = validationMessage.POSTAL_CODE;
  }

  if (form.basicUserName) {
    if (!isMaxLength(form.basicUserName, 127)) {
      validationErrors.basicUserName = `kintone Basic認証 ユーザーネームは127文字以内で入力してください。`;
    }
    if (!isAlphaUnderscoreHyphen(form.basicUserName)) {
      validationErrors.basicUserName = `kintone Basic認証 ユーザーネームは半角英数字、アンダースコア(-)、ハイフン(_)のみ使用できます。`;
    }
  }
  if (form.basicPassword) {
    if (!isWithinRange(form.basicPassword, 5, 64)) {
      validationErrors.basicPassword = `kintone Basic認証 パスワードは5~64文字以内で入力してください。`;
    }
    if (!isAlphaSpecialChar(form.basicPassword)) {
      validationErrors.basicPassword = `kintone Basic認証 パスワードに使用不可な文字が使用されています。`;
    }
  }

  setErrors(validationErrors);
  return Object.keys(validationErrors).length === 0;
};
